import * as React from "react";

export const reactType = (a: React.ReactElement<any>): any => a.type;
